"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basicAsync = void 0;
const augmentative_iterable_1 = require("augmentative-iterable");
const utils_1 = require("../utils");
const filter_async_1 = require("./filter-async");
const for_each_async_1 = require("./for-each-async");
const map_async_1 = require("./map-async");
const take_while_async_1 = require("./take-while-async");
const to_array_async_1 = require("./to-array-async");
exports.basicAsync = {
    map: map_async_1.mapAsync,
    resolver: augmentative_iterable_1.resolverAsync,
    forEach: for_each_async_1.forEachAsync,
    filter: filter_async_1.filterAsync,
    takeWhile: take_while_async_1.takeWhileAsync,
    iterate: utils_1.iterateAsync,
    iterateAll: utils_1.iterateAllAsync,
    toArray: to_array_async_1.toArrayAsync,
};
